import React from 'react'
import { TextField } from 'office-ui-fabric-react'

export function BidAdapterAliasInput({
  bidAdapterAlias,
  setBidAdapterAlias,
  errorMessage,
  disabled,
}: {
  bidAdapterAlias: string
  setBidAdapterAlias: (bidAdapterAlias: string) => void
  errorMessage: string
  disabled: boolean
}) {
  return (
    <TextField
      label="Bid Adapter Alias"
      errorMessage={errorMessage}
      value={bidAdapterAlias}
      styles={{
        root: {
          maxWidth: 'calc(50% - 8px)',
        },
      }}
      onChange={(_event, newBidAdapterAlias) => {
        setBidAdapterAlias(newBidAdapterAlias || '')
      }}
      disabled={disabled}
      required
    />
  )
}
